import React from "react";
import {
  BarChart,
  Bar,
  XAxis,
  YAxis,
  Tooltip,
  ResponsiveContainer,
  LabelList,
} from "recharts";

import * as Colors from "../Colors";
import {
  sortData,
  getDistinct,
  getLongestTick,
  formatLabelList,
  CustomXAxisLabel,
} from "./ChartHelper";

import "./Chart.css";

function getTooltip({ active, label, payload }) {
  if (active) {
    return (
      <div className="Tooltip">
        <p className="label">{`${label}: ${payload[0].value}`}</p>
      </div>
    );
  }
}

function CustomTick(props) {
  const { x, y, payload, fontSize } = props;

  const tickValue = isNaN(payload.value)
    ? payload.value
    : Number.parseFloat(payload.value).toFixed(0);
  return (
    <g transform={`translate(${x},${y})`}>
      <text
        x={0}
        y={0}
        dy={16}
        textAnchor="middle"
        fill={Colors.PURPLE}
        fontSize={fontSize}
        // transform="rotate(-35)"
      >
        {tickValue}
      </text>
    </g>
  );
}

function getTickLabelFontSize(data) {
  const longestTick = getLongestTick(data, "name");
  const distinctLabels = getDistinct(data, "name");

  const length = isNaN(longestTick)
    ? longestTick.length
    : Number.parseFloat(longestTick).toFixed(0).toString().length;

  if (length > 3) {
    if (distinctLabels.size > 8) {
      return "1.1rem";
    }
    if (distinctLabels.size > 6) {
      return "1.2rem";
    }
  }
  return "1.4rem";
}

export default function VerticalBar({ data, options }) {
  data = data ? data : [];
  data = sortData(data, options);
  const yLabel = options.yLabel ?? "Number of Responses";

  return (
    <ResponsiveContainer width="100%" height="100%">
      <BarChart
        data={data}
        margin={{
          top: 30,
          right: 10,
          left: -10,
          bottom: 30,
        }}
      >
        <Bar dataKey="value" fill={Colors.ORANGE} isAnimationActive={false}>
          <LabelList
            dataKey="value"
            position="top"
            fill={Colors.PURPLE}
            formatter={(value) => formatLabelList(value, yLabel, options)}
          />
        </Bar>
        <YAxis
          type="number"
          label={{
            value: yLabel,
            angle: -90,
            fill: Colors.PURPLE,
            dx: 10,
          }}
          tick={false}
          stroke={Colors.PURPLE}
        />
        <XAxis
          type="category"
          dataKey="name"
          tickLine={false}
          label={
            <CustomXAxisLabel
              label={options.xLabel}
              startLabel={options.xLabelStart}
              endLabel={options.xLabelEnd}
              dy={5}
            />
          }
          tick={<CustomTick fontSize={getTickLabelFontSize(data)} />}
          stroke={Colors.PURPLE}
          width={100}
          interval={0}
        />
        {options.showTooltip ? (
          <Tooltip
            cursor={{ fill: "transparent" }}
            content={(props) => getTooltip(props)}
          />
        ) : null}
      </BarChart>
    </ResponsiveContainer>
  );
}
